import { gql } from '@/__generated__';

const DGA_REPORTS_TABLE_GET_DEVICE = gql(`#graphql
  query DGAReportsTableModal_GetDeviceForSendEmailModal($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      profile {
        id
        name
      }
    }
  }
`);

export default DGA_REPORTS_TABLE_GET_DEVICE;
